export const cleanObject = (obj: object) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) => value !== 0 && value !== null && value !== '' && value !== undefined && value?.length !== 0
    )
  );
